function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavBilling = function SvgNavBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M196.45 37.82a14.96 14.96 0 0 0-10.22-5.27L45.38 20.8c-4-.33-7.89.91-10.95 3.5a14.9 14.9 0 0 0-5.26 10.17l-2.83 26.58H15.03C6.74 61.05 0 67.79 0 76.07v88.16c0 8.29 6.74 15.03 15.02 15.03h141.33c8.28 0 15.02-6.74 15.02-15.02v-14.3l5.02.42c.42.03.84.05 1.26.05 7.72 0 14.3-5.94 14.96-13.77l7.34-87.86c.33-4-.91-7.89-3.5-10.95Zm-32.89 126.42c0 3.98-3.23 7.21-7.21 7.21H15.02c-3.98 0-7.21-3.23-7.21-7.21v-48.3h155.75zm0-56.12H7.81V91.91h155.75zm0-24.01H7.81v-8.03c0-3.98 3.23-7.21 7.21-7.21h141.33c3.98 0 7.21 3.23 7.21 7.21zm21.27 51.87c-.33 3.96-3.82 6.92-7.78 6.58l-5.67-.47V76.07c0-8.28-6.74-15.02-15.02-15.02H34.19l2.75-25.8v-.09c.33-3.96 3.82-6.92 7.78-6.58l140.84 11.76c1.92.16 3.66 1.06 4.9 2.53a7.19 7.19 0 0 1 1.68 5.26l-7.34 87.86Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.41,
    height: 32.34,
    x: 105.71,
    y: 127.55,
    rx: 3.91,
    ry: 3.91,
    style: {
      fill: "#e3f9ff",
      strokeWidth: 0
    }
  }));
};
export default SvgNavBilling;